module.exports = __webpack_public_path__ + "static/img/MvpBg.e243d5d2.png";